import type { CSSProperties } from "react";

/**
 * Header controls keep the color hover and skip the shared button lift.
 * Hover and press must not change `translate` or fade the pill: a shifting
 * trigger flashes when the pointer moves between neighbouring controls.
 * Keyboard focus draws a light ring. The shared ring is primary-on-primary
 * here, so it would be invisible.
 * The invisible `::before` covers the 2px gap so the pointer never falls
 * between two pills.
 */
export const headerButtonClassName =
  "relative appearance-none shadow-none transition-none hover:translate-none active:translate-none focus:translate-none focus-visible:translate-none hover:shadow-none active:shadow-none focus:shadow-none focus-visible:shadow-none focus-visible:border-transparent focus-visible:ring-2 focus-visible:ring-primary-foreground before:absolute before:inset-y-0 before:-left-0.5 before:-right-0.5 before:content-['']";

const headerToolInteractionClassName =
  "hover:bg-white hover:text-primary focus-visible:bg-white focus-visible:text-primary active:bg-white active:text-primary";

/**
 * Course tools put the icon above the label so the header stays one line.
 * Overrides the shared `sm` size, which is a fixed 32px row, and the pill
 * radius, which bulges under a stacked label.
 */
export const headerStackedToolClassName =
  "h-auto flex-col gap-0.5 rounded-lg px-2 py-1 text-xs leading-none";

/** Same white pill for hover, keyboard focus, and press. */
export const headerToolClassName = (selected: boolean) =>
  selected
    ? `bg-white text-primary ${headerToolInteractionClassName}`
    : `bg-transparent ${headerToolInteractionClassName}`;

/** Stops a header menu from sliding up over its trigger while it opens. */
export const headerMenuEnterStyle = {
  "--tw-enter-translate-y": "0px",
} as CSSProperties;

/** Pointer opens must not move focus, or the trigger highlight flashes. */
export const keepHeaderMenuTriggerFocused = (
  openedWithPointer: { current: boolean },
  event: Event
) => {
  if (openedWithPointer.current) {
    event.preventDefault();
  }
};
